import React from "react";

const Footer = () => {
  return (
    <div className="footer">
      <footer>
        <p> © {new Date().getFullYear()} | designed by moi </p>
      </footer>
    </div>
  );
};

export default Footer;
